export default __webpack_public_path__ + "static/media/bat.5f7290a6.svg";